import type { ReactElement } from 'react';
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { CircularProgress, Box } from '@mui/material';

import { useAppContext } from '../components/authentication/account';
import { adminSelector } from '../store/selectors/adminSelector';
import type { AdminRole } from '../types/types';

export default function RoleProtectedRoute({
  allowedRoles,
  children,
  redirectTo = '/root/dashboard',
}: {
  allowedRoles: AdminRole[];
  children: ReactElement;
  redirectTo?: string;
}): ReactElement {
  const { pathname, search } = useLocation();
  const { isAuthenticated } = useAppContext();
  const admin = useSelector(adminSelector);

  if (!isAuthenticated) {
    return <Navigate to={`/login?redirect=${pathname}${search}`} />;
  }

  // Admin info is loaded asynchronously in Root; avoid flashing unauthorized.
  if (!admin.adminId) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!allowedRoles.includes(admin.admin_role)) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
}
